import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { GroupsListingModel, GroupsGridPostParams } from 'common/models/page-models/groups/groups-grid-model';
import { GroupsModel } from 'common/models/page-models/groups/groups-model';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class GroupsGridDataService extends GridDataService<GroupsListingModel, GroupsModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getGroupList, http, ss);
    }

    createInstance(): GroupsListingModel {
        return new GroupsListingModel();
    }

    getDeleteUrl() {
        return environment.apiUrl +  API_URL.deleteGroup
    }

    override getDeletePayload(data) {
        let payload;
        if(Object.keys(data).length > 1) {
            payload = {
                id: data.id
            }
        } else{
            payload = data;
        }
        return payload;
    }

    override getGridParams(): GridPostParams {
        return new GroupsGridPostParams();
    }

    
}
